import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { CategoryStoreSelectors, LocationsRouterStoreSelectors } from '@era/stores';
import { Store } from '@ngrx/store';
import { SelectLocationListComponent } from '@rocksoft/shared';

@Component({
  selector: 'era-select-location-list-devices',
  templateUrl: './select-location-list-devices.container.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SelectLocationListComponent],
})
export class SelectLocationListDevicesContainerComponent {
  private readonly store = inject(Store);

  public readonly locations = this.store.selectSignal(
    CategoryStoreSelectors.selectAllCategoryEntitiesByType('Location')
  );
  public readonly location = this.store.selectSignal(LocationsRouterStoreSelectors.selectLocation);
  public readonly brandId = this.store.selectSignal(LocationsRouterStoreSelectors.selectBrandId);
}
